/**
 * MAS Indirect save payload - delegates to shared MAS payload builder.
 * Isolated so Indirect-specific payload changes can be made here without affecting Direct.
 */
import { buildMASSavePayload } from '../../shared/utils/masPayloadBuilder';
import type { FormDataArrayItem } from '../../shared/utils/masPayloadBuilder.types';
import type { MASSavePayloadDeps } from '../../shared/utils/masPayloadBuilder.types';

export function buildMASIndirectSavePayload(deps: MASSavePayloadDeps): FormDataArrayItem[] {
  return buildMASSavePayload(deps);
}
